import { cva } from 'cva'

export const chipV2Style = cva({
  base: [
    ['py-[11px] border-[1.5px] rounded-lg text-lg flex-1'],
    ['data-[selected=selected]:border-gray-900', 'data-[selected=selected]:bg-green-100'],
    ['data-[selected=un-selected]:border-gray-200', 'data-[selected=un-selected]:bg-white'],
  ],

  variants: {
    direction: {
      vertical: ['px-4'],
      horizontal: ['px-2'],
    },
  },

  defaultVariants: {
    direction: 'vertical',
  },
})
